import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import moment from "moment";
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import { GetApp } from '@material-ui/icons';
import { CSVLink } from "react-csv";
import * as C from 'components';

const useStyles = makeStyles({
  loaderBox: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  loaderBarImg: {
    width: 40,
  },
  tableContainer: {
    display: 'flex',
    minHeight: 200,
  },
  dateTableWrapper: {
    float: 'left',
  },
  dataTableWrapper: {
    float: 'left',
    overflow: 'scroll',
  },
  leftTable: {
    border: '1px solid #eee',
  },
  lblGameName: {
    color: '#000',
    fontSize: 13,
    minWidth: 200,
  },
  lblUniqueUser: {
    color: '#6f6969',
    fontSize: 11,
    minWidth: 180,
  },
  _GAIv: {
    height: 40,
    backgroundColor: "#4#4#4",
    borderLeft: "1px solid #eee6e6",
    color: "#666",
    fontSize: 11,
    minWidth: 80,
    paddingRight: 10,
    textAlign: 'right',
  },
  dataHeaderTd: {
    width: 100,
    paddingRight: 10,
    borderBottom: '1px solid #eee6e6',
  },
  dataTableBody: {
    fontSize: 11,
    paddingRight: 10,
    paddingBottom: 0,
    textAlign: 'right',
    verticalAlign: 'middle',
    border: '1px solid #eee6e6',
    height: '3em',
    overflowX: 'auto',
  },
  dataCellTd: {
    fontSize: 13,
    paddingRight: 10,
    paddingBottom: 0,
    paddingLeft: 10,
    textAlign: 'right',
    verticalAlign: 'middle',
    borderBottom: '1px solid #eee6e6',
    borderRight: '1px solid #eee6e6',
    height: 45,
  },
  tTdHeader: {
    paddingLeft: '1rem',
    paddingRight: 19,
    fontWeight: 'bold',
    height: 39,
  },
  tTd: {
    height: 44,
    width: 250,
    paddingLeft: '1rem',
    borderBottom: '1px solid #eee',
    borderCollapse: 'collapse',
  },
  tableNumberData: {
    fontSize: 13,
    paddingBottom: 4,
  },
  exportBtn: {
    marginLeft: 16,
  },
  titleContainer: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  widgetTitle: {
    flexBasis: '50%',
    fontSize: 16,
    padding: 16,
  },
  exportBtnContainer: {
    marginLeft: 'auto',
    padding: 16,
  }
});

const PicTreeTableReport = ({ reportTrend, pageTopLoader }) => {
  const classes = useStyles();

if (!Array.isArray(reportTrend) || reportTrend.length === 0) {
    return (
      null
    );
  }


  const dates = reportTrend.map(d => d.date);
  const tagKeys = reportTrend.length > 0
    ? Object.keys(reportTrend[0]).filter(key => key !== "date")
    : [];

  const getLabelColumn = () => (
    <>
      {tagKeys.map(tag => (
        <tr key={tag}>
          <td className={classes.tTd}>
            <div className={classes.lblGameName}>{tag}</div>
          </td>
        </tr>
      ))}
    </>
  );

  const getDataTable = () => (
    <>
      {tagKeys.map(tag => (
        <tr key={tag}>
          {reportTrend.map((row, i) => (
            <td key={i} className={classes.dataCellTd}>
              {row[tag] ?? 0}
            </td>
          ))}
        </tr>
      ))}
    </>
  );

  const getExportData = () => {
    const exportData = [];
    const header = ["タグ別日別報告件数", ...dates];
    exportData.push(header);

    tagKeys.forEach(tag => {
      const row = [tag];
      reportTrend.forEach(entry => {
        row.push(entry[tag] ?? 0);
      });
      exportData.push(row);
    });

    return exportData;
  };

  return (
    <Paper>
      <div className={classes.titleContainer}>
        <div className={classes.widgetTitle}>タグ別日別報告件数</div>
        <div className={classes.exportBtnContainer}>
          <CSVLink data={getExportData()} filename={`PicTree - 報告トレンド`}>
            <Button
              variant="contained"
              color="default"
              className={classes.exportBtn}
              startIcon={<GetApp />}
            >
              CSV出力
            </Button>
          </CSVLink>
        </div>
      </div>
      <div className={classes.tableContainer}>
        {pageTopLoader ? (
          <div className={classes.loaderBox}>
            <img className={classes.loaderBarImg} src={`/static/images/loader-bar.gif`} />
          </div>
        ) : reportTrend.length > 0 ? (
          <>
            <div className={classes.dateTableWrapper}>
              <table className={classes.leftTable}>
                <tbody>
                  <tr><td className={classes.tTdHeader}></td></tr>
                  {getLabelColumn()}
                </tbody>
              </table>
            </div>
            <div className={classes.dataTableWrapper}>
              <table className={classes.dataTableBody}>
                <tbody>
                  <tr className={classes._GAIv}>
                    {dates.map((date, i) => (
                      <td key={i} className={classes.dataHeaderTd}>
                        {moment(date).format("M/D")}
                      </td>
                    ))}
                  </tr>
                  {getDataTable()}
                </tbody>
              </table>
            </div>
          </>
        ) : (
          <div className={classes.loaderBox}><C.NoData text="No Data" /></div>
        )}
      </div>
    </Paper>
  );
};

PicTreeTableReport.propTypes = {
    classes: PropTypes.object,
};

const mapStateToProps = state => ({
  reportTrend: state.pictree.reportTrend.data,
  pageTopLoader: state.page.pageTopLoader,
});

const mapDispatchToProps = dispatch => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(PicTreeTableReport);